export const getLang = (state) => state.user.lang;
export const getContacts = (state) => state.user.contacts;
export const getCart = (state) => state.cart.cart;
export const getIsCartUpdated = (state) => state.cart.isCartUpdated;
export const getProducts = (state) => state.products.products;
export const getCategories = (state) => state.products.categories;
export const getIsProductsLoading = (state) => state.products.isLoading;
export const getStores = (state) => state.stores.stores;
export const getIsStoresLoading = (state) => state.stores.isLoading;
